<template>
  <b-form>
    <b-row>
      <b-col md="6">
        <b-form-group v-if="origin === 'scheduled_delivery'">
          <b-form-checkbox
            v-model="selectedValue.same_deliver_now"
            :name="`${origin}_same_delivery_now`"
            @input="handleSameAsDeliverNow"
          >
            <span class="offset-top">Same as Deliver Now</span>
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-radio-group
            :id="`${origin}-fees-type`"
            v-model="selectedValue.delivery_fee_type"
            :options="typeOptions"
          >
          </b-form-radio-group>
          <b-form-invalid-feedback
            :force-show="!isInvalid(`${origin}.delivery_fee_type`)"
          >
            {{ errorMessage(`${origin}.delivery_fee_type`) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Base Fee Value"
          label-class="grey"
          :state="isInvalid(`${origin}.base_fee_value`)"
          :invalid-feedback="errorMessage(`${origin}.base_fee_value`)"
        >
          <b-input-group size="md" prepend="Php">
            <currency-amount-input
              placeholder="0.00"
              v-model="selectedValue.base_fee_value"
            />
          </b-input-group>
        </b-form-group>
        <b-form-group
          label="Base Kilometer Range"
          label-class="grey"
          :state="isInvalid(`${origin}.base_km_range`)"
          :invalid-feedback="errorMessage(`${origin}.base_km_range`)"
          v-if="selectedValue.delivery_fee_type === 'dynamic'"
        >
          <b-input-group size="md" prepend="km">
            <currency-input
              v-model="selectedValue.base_km_range"
              placeholder="0"
              :value="selectedValue.base_km_range"
              :options="{ currency: 'Php', currencyDisplay: 'hidden' }"
            />
          </b-input-group>
        </b-form-group>
        <b-form-group
          label="Added Value per Kilometer"
          label-class="grey"
          :state="isInvalid(`${origin}.added_value_per_km`)"
          :invalid-feedback="errorMessage(`${origin}.added_value_per_km`)"
          v-if="selectedValue.delivery_fee_type === 'dynamic'"
        >
          <b-input-group size="md" prepend="Php">
            <currency-amount-input
              placeholder="0.00"
              v-model="selectedValue.added_value_per_km"
            />
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <div class="d-flex align-items-center">
            <span class="label-type-2 mr-2">Minimum Spend Delivery</span>
            <switches
              v-model="selectedValue.enable_minimum_spend"
              @input="$root.$emit('changesDetected')"
              theme="custom"
              color="primary"
              type-bold="true"
              style="top: 12px"
              :emit-on-mount="false"
            />
            <span class="ml-2">
              <small class="text-muted">{{
                `${selectedValue.enable_minimum_spend ? "Enabled" : "Disabled"}`
              }}</small>
            </span>
          </div>
        </b-form-group>
        <b-form-group
          label="Minimum Spend Amount"
          label-class="grey"
          v-if="selectedValue.enable_minimum_spend"
          :state="isInvalid(`${origin}.minimum_spend_amount`)"
          :invalid-feedback="errorMessage(`${origin}.minimum_spend_amount`)"
        >
          <div class="d-flex align-items-center">
            <b-input-group size="md" prepend="Php">
              <currency-amount-input
                placeholder="0.00"
                v-model="selectedValue.minimum_spend_amount"
              />
            </b-input-group>
            <i class="ic-tooltip ml-2" :id="`help-minimum-spend-${origin}`"></i>
            <b-popover
              :target="`help-minimum-spend-${origin}`"
              triggers="hover"
              content="Offer free delivery and set a minimum spend requirement."
            >
            </b-popover>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapGetters } from "vuex";
import Switches from "vue-switches";
import CurrencyInput from "@/components/common/CurrencyInput";
import CurrencyAmountInput from "@/components/common/CurrencyAmountInput.vue";

export default {
  name: "FulfillmentFeesForm",
  props: ["origin", "selectedValue"],
  components: { Switches, CurrencyInput, CurrencyAmountInput },
  data() {
    return {
      typeOptions: [
        { value: "fixed", text: "Fixed" },
        { value: "dynamic", text: "Dynamic" },
      ],
      oldValue: JSON.stringify(this.selectedValue),
    };
  },
  computed: {
    ...mapGetters({
      errors: "orderFulfillment/errors",
    }),
  },
  watch: {
    selectedValue: {
      handler() {
        const mustBeNumbers = [
          "base_fee_value",
          "base_km_range",
          "added_value_per_km",
          "minimum_spend_amount",
        ];

        const transformedValues = JSON.parse(
          JSON.stringify(this.selectedValue)
        );

        Object.keys(this.selectedValue).forEach((key) => {
          if (mustBeNumbers.includes(key) && this.selectedValue[key])
            transformedValues[key] = Number(this.selectedValue[key].toString().replace(/,/g, ""));
        });

        if (this.oldValue !== JSON.stringify(transformedValues))
          this.$root.$emit("changesDetected");
      },
      deep: true,
    },
  },
  methods: {
    handleSameAsDeliverNow(value) {
      if (value) this.$emit("getDeliverNowSettings");

      this.$root.$emit("changesDetected");
    },
    isInvalid(key) {
      return this.errors && this.errors[key] ? false : null;
    },
    errorMessage(key) {
      return this.errors && this.errors[key] ? this.errors[key] : null;
    },  
  },
};
</script>

<style lang="scss" scoped>
.offset-top {
  position: relative;
  top: -3px;
}
.form-group {
  &.is-invalid {
    .input-group {
      border: solid 1px #dc3545;
      border-radius: 5px;
      .input-group-text,
      .form-control {
        border: 0;
      }
    }
  }
}
</style>

<style lang="scss">
@import url("../../assets/scss/fulfillment/_base.scss");
.col-form-label.grey {
  color: #68737d;
}
[id*="-fees-type"]
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background: white;
  border-radius: 10px;
  width: 10px;
  height: 10px;
  top: 7px !important;
  left: -21px !important;
}
</style>
